import React from "react";
import { appColors, appType } from "../../utils/appTheme";

const fmt = new Intl.NumberFormat("es-UY", { maximumFractionDigits: 2 });

/**
 * Formatea un monto para la UI de residente.
 * @param {number|string} value
 * @returns {string} sin símbolo de moneda
 */
export function formatAmount(value) {
  if (value === null || value === undefined || value === "") return "0";
  if (typeof value === "string") {
    const n = Number(value.replace(/[^\d.-]/g, ""));
    return Number.isFinite(n) ? fmt.format(n) : value;
  }
  return fmt.format(value);
}

/**
 * Monto grande al estilo app, a PESO 400.
 * La jerarquía se logra con tamaño + color ink + tabular-nums + tracking + "$" chico.
 * tone: opcional 'red'|'green' para montos con signo (deuda/pago).
 */
const Money = ({ value, currency = "$", size = 34, tone, color, style }) => {
  const numColor =
    color ||
    (tone === "red"
      ? appColors.red
      : tone === "green"
      ? appColors.green
      : appColors.ink);
  return (
    <span
      style={{
        ...appType.amount,
        fontSize: size,
        color: numColor,
        display: "inline-flex",
        alignItems: "flex-start",
        gap: 3,
        ...style,
      }}
    >
      <span
        style={{
          ...appType.amountCurrency,
          fontSize: Math.round(size * 0.58),
          color: color || appColors.ink3,
        }}
      >
        {currency}
      </span>
      {formatAmount(value)}
    </span>
  );
};

export default Money;
